<template>
  <div class="row">
    <div class="configurator-info-block blog-asside-right col-md-3">
      <div class="logo-block">
        <a class="" href=""><img :src="'/images/exhibitions/' + exhibitionImage" alt=""></a>
      </div>
      <div class="configurator-info-content">
        <configurator-exhibition
          class="hidden-xs hidden-sm"
          :exhibition="request.exhibition">
        </configurator-exhibition>
        <print-cloud-request :request="request"></print-cloud-request>
        <configurator-contact v-if="request.exhibition.contact"
          class="hidden-xs hidden-sm"
          :contact="request.exhibition.contact">
        </configurator-contact>
      </div>
    </div>
    <div class="configurator-content-block blog-lst col-md-9 p1">
      <ul class="list-unstyled lang-block">
        <li>
          <a href="#" @click="$i18n.locale = 'de'" :class="{'active': !inEnglish}">
            <img class="flag" src="/images/de.svg" alt=""/>
          </a>
        </li>
        <li>
          <a href="#" @click="$i18n.locale = 'en'" :class="{'active': inEnglish}">
            <img class="flag" src="/images/gb.svg" alt=""/>
          </a>
        </li>
      </ul>
      <div class="clearfix">
        <h2 class="mt-4">
          {{ $t('configurator.headings.print_cloud') }}
        </h2>
        <template v-if="booth && affectedBoothArticles.length > 0">
          <print-job-booth
            :articles="affectedBoothArticles"
            :booth="booth"
            :print-job="printJob"
            :booth-type="request.booth_type">
          </print-job-booth>
        </template>

        <template v-for="article in affectedPrintableArticles" :key="article.id">
          <print-job-article :article="article" :print-job-configurations="configurations">
          </print-job-article>
        </template>
        <a v-if="showDownloadAllLink"
          :href="downloadAllLink"
          class="btn btn-primary cursor--pointer mt-4">
          <i class="fa fa-download"></i> <b>{{ $t('configurator.buttons.download_all_files') }}</b>
        </a>
      </div>
    </div>
  </div>
  <app-footer></app-footer>
</template>

<script setup>
import { computed, onMounted, watch } from 'vue'
import { useMainStore } from '@/store'
import PrintJob from '@/classes/PrintJob'
import { useI18n } from 'vue-i18n'
import PrintCloud from '@/classes/PrintCloud'
import { PRINT_CLOUD_STATUS_FINISHED } from '@/constants'

const { t, locale } = useI18n({ useScope: 'global' })
const store = useMainStore()
// define passed props
const props = defineProps({
  printJob: {
    type: Object,
    required: true,
  },
  request: {
    type: Object,
    required: true,
  },
  articles: {
    type: Array,
    default: [],
  },
  booth: {
    type: Object,
    default: null
  },
  configurations: {
    type: Array,
    default: []
  }
})

// define computed props
const storedLocale = computed(() => store.settings.locale)
const job = computed(() => store.tmp.printJob)

const inEnglish = computed(() => {
  return storedLocale.value === 'en'
})

const exhibitionImage = computed(() => {
	if (props.request.exhibition.logo !== null && props.request.exhibition.logo != "") {
		return props.request.exhibition.logo
	}

	return "default_configurator_logo.png"
})

const affectedPrintableArticles = computed(() => {
  const articleIds = props.configurations
    .filter((configuration) => {
      return (configuration.configuration.request_article.article_print_id !== null)
    })
    .map((configuration) => {
      return configuration.configuration.request_article.parent_id
    })

  return props.articles.filter((article) => articleIds.includes(article.article_id))
})

const affectedBoothArticles = computed(() => {
  const articleIds = props.configurations
    .filter((upload) => {
      return (upload.configuration.request_article.booth_refinement_id !== null)
    })
    .map((upload) => {
      return upload.configuration.request_article.article_id
    })

  return props.articles.filter((article) => articleIds.includes(article.article_id))
})

const affectedBoothPrintArticles = computed(() => {
  const articleIds = props.configurations
    .filter((upload) => {
      return (
        upload.configuration.request_article.booth_refinement_id !== null
        && upload.configuration.is_logo_print
      )
    })
    .map((upload) => {
      return upload.configuration.request_article.article_id
    })

  return props.articles.filter((article) => articleIds.includes(article.article_id))
})

const downloadAllLink = computed(() => {
  if (job.value === undefined || job.value === null) {
    return '#'
  }

  return '/print-job/' + job.value.uuid + '/download-all'
})

const showDownloadAllLink = computed(() => {
  return (
    (affectedBoothPrintArticles.value.length > 0 || affectedPrintableArticles.value.length > 0)
    && !props.printJob.print_cloud.status !== PRINT_CLOUD_STATUS_FINISHED
  )
})

// define watch
watch(() => locale.value, () => {
	selectLocale(locale.value)
})
// define methods
const selectLocale = async (val) => {
	if (storedLocale.value === val) {
		return
	}

	store.settings.locale = val
	await axios.post('/locale', { language: val })
		.then(response => {
    })
		.catch(err => {
			console.error(err)
		});
}

onMounted(() => {
  store.tmp.printJob = new PrintJob(props.printJob)
  store.tmp.cloud = new PrintCloud(props.printJob.print_cloud)
  store.tmp.booth_draft = props.request.booth_draft
})
</script>